import React from 'react'
import styled from 'styled-components'
import { MapControl } from '../../../atoms/MapControl'

const ZoomControls = styled.div<{ $position: string }>`
  position: absolute;
  ${({ $position }) => {
    switch ($position) {
      case 'top-left':
        return 'top: 16px; left: 16px;'
      case 'top-right':
        return 'top: 16px; right: 16px;'
      case 'bottom-left':
        return 'bottom: 24px; left: 16px;'
      case 'bottom-right':
        return 'bottom: 24px; right: 16px;'
      default:
        return 'bottom: 24px; left: 16px;'
    }
  }}
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1;

  @media (max-width: 768px) {
    bottom: 16px;
    left: 8px;
  }
`

const ControlGroup = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

const StyledMapControl = styled(MapControl)`
  border-radius: 0;
  box-shadow: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);

  &:last-child {
    border-bottom: none;
  }

  &:first-child {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  &:last-child {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`

interface MapZoomControlsProps {
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  showCompass?: boolean
  onZoomIn?: () => void
  onZoomOut?: () => void
  onCompassClick?: () => void
  mapBearing?: number
}

export const MapZoomControls: React.FC<MapZoomControlsProps> = ({
  position = 'bottom-left',
  showCompass = true,
  onZoomIn,
  onZoomOut,
  onCompassClick,
  mapBearing = 0,
}) => {
  return (
    <ZoomControls $position={position}>
      <ControlGroup>
        {/* Compass Control - only show when map is rotated or when explicitly enabled */}
        {showCompass && (
          <StyledMapControl
            icon={
              <svg
                viewBox="0 0 24 24"
                width="32"
                height="32"
                style={{
                  transform: `rotate(${-mapBearing}deg)`,
                }}
              >
                <path d="M12 2L8 6h3v10h2V6h3L12 2z" fill="currentColor" />
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
              </svg>
            }
            title="Reset to North"
            onClick={onCompassClick}
          />
        )}

        {/* Zoom In */}
        <StyledMapControl
          icon={
            <svg viewBox="0 0 24 24" width="16" height="16">
              <path
                d="M12 4v16m8-8H4"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            </svg>
          }
          title="Zoom In"
          onClick={onZoomIn}
        />

        {/* Zoom Out */}
        <StyledMapControl
          icon={
            <svg viewBox="0 0 24 24" width="16" height="16">
              <path
                d="M20 12H4"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            </svg>
          }
          title="Zoom Out"
          onClick={onZoomOut}
        />
      </ControlGroup>
    </ZoomControls>
  )
}
